// extracted by mini-css-extract-plugin
module.exports = {"tagsForm":"TagsTable_tagsForm__YNKcR","submitButton":"TagsTable_submitButton__5hPNU"};